import type { MachineOwnershipData } from '~/data/Asset';
import BFFAPI from './utils/BFFAPI';

class ProductDataAPI extends BFFAPI {
  editOwnershipData = (
    machineId: string,
    ownershipData: MachineOwnershipData
  ) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/${machineId}`,
      ownershipData
    );
    return this.fetch(req);
  };
}

export default new ProductDataAPI('/fleet/secure/product-data');
